<template>
    <el-menu class="Sidebar-container"
        ref="sidebarMenu"
        background-color="#0A64FE"
        text-color="#fff"
        active-text-color="#fff"
        :default-active="defaultPath"
        :collapse="collapse"
        @select="select_menu">
        <sidebar-item :routes="menuList" />
    </el-menu>
</template>

<script>
import SidebarItem from './SidebarItem';
import { jump } from '_libs/util';
import menuList from '@/router/menu';
import { mapState } from 'vuex';

export default {
    props:{
        collapse: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            // defaultPath: this.$store.state.user.toPath,
            menuList
        }
    },
    methods: {
        select_menu(index, indexPath){
            if(this.$route.path == index) return false;
            this.$store.commit('SET_TO_PATH', index);
            this.$go({path:index})
            //old-页面没有登录不能使用route跳转
            // jump(index);
        },
        openMenu(index){
            // this.defaultPath = index
            // const Fn = getObjVal(this,'$refs.sidebarMenu.open')
            // return Fn && Fn(index);
        }
    },
    created(){
    },
    mounted(){
    },
    computed: {
        ...mapState({
            defaultPath: state => state.user.toPath,
        }),
    },
    components: {
        SidebarItem,
    },
};
</script>



// WEBPACK FOOTER //
// src/components_v3/layout/left-sider/left-sider.vue